/* Progressive, local-only product preview; video loads after an explicit play. */
(() => {
  if (!customElements.get('mm-light-preview')) {
    customElements.define('mm-light-preview', class extends HTMLElement {
      connectedCallback() {
        this.onClick = event => {
          const control = event.target.closest('[data-light-state]');
          if (!control || !this.contains(control)) return;
          const state = control.dataset.lightState;
          if (!['muted', 'live'].includes(state)) return;
          this.dataset.state = state;
          this.querySelectorAll('[data-light-state]').forEach(button => button.setAttribute('aria-pressed', String(button === control)));
          this.querySelector('.mm-home-photo--muted')?.setAttribute('aria-hidden', String(state !== 'muted'));
          this.querySelector('.mm-home-photo--live')?.setAttribute('aria-hidden', String(state !== 'live'));
          const status = this.querySelector('[data-light-status]');
          if (status) status.textContent = state === 'live' ? 'Live' : 'Muted';
        };
        this.addEventListener('click', this.onClick);
        const fieldset = this.querySelector('fieldset');
        if (fieldset) fieldset.disabled = false;
      }
      disconnectedCallback() { this.removeEventListener('click', this.onClick); }
    });
  }
  if (!customElements.get('mm-home-film')) {
    customElements.define('mm-home-film', class extends HTMLElement {
      connectedCallback() {
        this.play = this.querySelector('[data-film-play]');
        this.onClick = event => {
          if (event.target.closest('[data-film-close]')) { this.stop(); this.play.focus(); return; }
          if (!event.target.closest('[data-film-play]') || this.frame) return;
          if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const id = this.dataset.videoId;
          const type = this.dataset.videoType;
          if (!id || !['youtube','vimeo'].includes(type)) return;
          event.preventDefault();
          const frame = document.createElement('iframe');
          frame.title = 'The MuteMe film';
          frame.src = type === 'vimeo' ? `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          this.closeButton = document.createElement('button');
          this.closeButton.type = 'button';
          this.closeButton.className = 'mm-home-film__close';
          this.closeButton.dataset.filmClose = '';
          this.closeButton.textContent = 'Close film ×';
          this.play.hidden = true;
          this.frame = frame;
          this.append(frame, this.closeButton);
          this.closeButton.focus();
        };
        this.onKey = event => { if (event.key === 'Escape' && this.frame) { this.stop(); this.play.focus(); } };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
      }
      stop() { this.frame?.remove(); this.closeButton?.remove(); this.frame = null; if (this.play) this.play.hidden = false; }
      disconnectedCallback() { this.stop(); this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey); }
    });
  }
})();
